'use client';

import React from 'react';
import { FaTimes } from 'react-icons/fa';
import Button from '@/components/ui/Button';
import Input from '@/components/ui/Input';

interface CashInModalProps {
  isOpen: boolean;
  onClose: () => void;
  formData: {
    payment_id: string;
    amount: string;
    transaction_id: string;
    holder_phone: string;
  };
  onInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: () => void;
  isLoading?: boolean;
}

const CashInModal: React.FC<CashInModalProps> = ({
  isOpen,
  onClose,
  formData,
  onInputChange,
  onSubmit,
  isLoading = false
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Cash In</h3>
          <button onClick={onClose} className="modal-close">
            <FaTimes />
          </button>
        </div>
        <div className="modal-body">
          <div className="form-group">
            <Input
              label="Payment Method ID"
              name="payment_id"
              type="number"
              value={formData.payment_id}
              onChange={onInputChange}
              placeholder="Enter payment method ID"
            />
          </div>
          <div className="form-group">
            <Input
              label="Amount"
              name="amount"
              type="number"
              value={formData.amount}
              onChange={onInputChange}
              placeholder="Enter amount"
            />
          </div>
          <div className="form-group">
            <Input
              label="Transaction ID"
              name="transaction_id"
              type="text"
              value={formData.transaction_id}
              onChange={onInputChange}
              placeholder="Enter transaction ID"
            />
          </div>
          <div className="form-group">
            <Input
              label="Holder Phone"
              name="holder_phone"
              type="tel"
              value={formData.holder_phone}
              onChange={onInputChange}
              placeholder="Enter phone number"
            />
          </div>
        </div>
        <div className="modal-footer">
          <Button
            variant="casino"
            onClick={onSubmit}
            isLoading={isLoading}
            disabled={!formData.payment_id || !formData.amount || !formData.transaction_id || !formData.holder_phone}
          >
            Submit
          </Button>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CashInModal;
